import React from 'react';
import PropTypes from 'prop-types';

const ItemComponent = (props) => {
  const {
    title, cond, amount, count, onChangeAmount, onChangeCount
  } = props;

  if (cond) {
    return (
      <>
        <div className="leftDiv">{title}</div>
        <div className="rightDiv">{`${amount}번 ${count}개`}</div>
      </>
    );
  }
  return (
    <>
      <div className="leftDiv">{title}</div>
      <div className="rightDiv">
        <input
          className=""
          placeholder="발급 수량 입력"
          type="number"
          value={amount}
          onChange={onChangeAmount}
          style={{ width: 320 }}
        />
        <input
          className=""
          placeholder="발급 수량 입력"
          type="number"
          value={count}
          onChange={onChangeCount}
          style={{ width: 320 }}
        />
      </div>
    </>
  );
};

ItemComponent.propTypes = {
  title: PropTypes.string.isRequired,
  cond: PropTypes.bool.isRequired,
  amount: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  onChangeAmount: PropTypes.func.isRequired,
  onChangeCount: PropTypes.func.isRequired,
};

export default ItemComponent;
